import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "~/services/api";
import { Attachments, C, Icon, IconButton, MODULES, buildFormData, errorMessage, inputStyle, moduleFromPath, useFileDrop } from "./tickets";

const TYPES = [
  { value: "bug", icon: "Bug", title: "Something is broken" },
  { value: "feature", icon: "Lightbulb", title: "I need something new" },
];

export default function TicketForm({ draft, onCreated }) {
  const [type, setType] = useState("bug");
  const [module, setModule] = useState(moduleFromPath());
  const [title, setTitle] = useState(draft?.title || "");
  const [description, setDescription] = useState(draft?.description || "");
  const [files, setFiles] = useState([]);
  const [sending, setSending] = useState(false);
  const drop = useFileDrop(setFiles);

  async function submit(e) {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      const { data } = await api.post(
        "/tickets",
        buildFormData(
          { type, module, title, description, page_url: window.location.pathname, source: draft ? "chatbot" : "system" },
          files
        )
      );
      toast(`${data.code} created`, { autoClose: 2500 });
      onCreated(data.id);
    } catch (error) {
      toast.error(errorMessage(error));
    } finally {
      setSending(false);
    }
  }

  return (
    <form onSubmit={submit} {...drop.handlers} style={{ display: "flex", flexDirection: "column", gap: 10, padding: 12, overflowY: "auto", flex: 1, background: C.secondary, outline: drop.over ? `2px dashed ${C.orange}` : "none", outlineOffset: -6 }}>
      <div style={{ display: "flex", gap: 8 }}>
        {TYPES.map((item) => (
          <button
            key={item.value}
            type="button"
            title={item.title}
            onClick={() => setType(item.value)}
            style={{
              flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 6, padding: "10px 0", borderRadius: 10, cursor: "pointer", fontSize: 12, fontWeight: 600,
              border: `2px solid ${type === item.value ? C.orange : C.secondaryDark}`, background: C.white, color: type === item.value ? C.orange : C.textMid,
            }}
          >
            <Icon name={item.icon} size={18} />
            {item.value === "bug" ? "Bug" : "Feature"}
          </button>
        ))}
      </div>

      <select value={module} onChange={(e) => setModule(e.target.value)} style={inputStyle}>
        {MODULES.map((m) => (
          <option key={m.value} value={m.value}>{m.label}</option>
        ))}
      </select>

      <input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Title" maxLength={200} required style={inputStyle} />
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder={type === "bug" ? "What happened? What did you expect?" : "What should it do?"}
        rows={6}
        required
        style={{ ...inputStyle, resize: "none" }}
      />

      <Attachments files={files} setFiles={setFiles} />

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <IconButton name={sending ? "Loader" : "Send"} title="Create ticket" solid color={C.orange} disabled={sending || title.trim().length < 3 || description.trim().length < 3} onClick={submit} />
      </div>
    </form>
  );
}
